export const cos = (angle: number): number => Math.cos((angle * Math.PI) / 180)
